import { defaultThemeColors } from './defaultThemeColors';
export var defaultBadgeVariants = {
    primary: {
        backgroundColor: defaultThemeColors.primaryLightest,
        color: defaultThemeColors.primaryDark,
    },
    success: {
        backgroundColor: defaultThemeColors.greenLightest,
        color: defaultThemeColors.greenDark,
    },
    danger: {
        backgroundColor: defaultThemeColors.redLightest,
        color: defaultThemeColors.redDark,
    },
    warning: {
        backgroundColor: defaultThemeColors.orangeLightest,
        color: defaultThemeColors.orangeDark,
    },
    info: {
        backgroundColor: defaultThemeColors.blueLightest,
        color: defaultThemeColors.blueDark,
    },
    grey: {
        backgroundColor: defaultThemeColors.greyLight,
        color: defaultThemeColors.greyDarker,
    },
};
//# sourceMappingURL=defaultBadgeVariants.js.map